import { useServiceError } from "../../Hooks/Features/Inspectra/useServiceError";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import Highcharts3D from "highcharts/highcharts-3d";
import { Dialog } from "primereact/dialog";
import DatePicker from "react-multi-date-picker";
import { SkeletonContainer } from "../Loader/Loader";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { dateConvert, timePickerMuiCss } from "../../utils/Helper";
import Pagination from "../CommonCompo/Pagination/pagination";
import { Calendar } from "primereact/calendar";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
Highcharts3D(Highcharts);

const ServiceError = ({ autopopData, projectChanged }) => {

    const { options, showPopup, setShowPopup, popupData, expandedIndex, setExpandedIndex, hoveredRange, loader, showFilter, setShowFilter, filterValues, setFilterValues, filterCount, expand, setExpand, totalPages, currentPage, setCurrentPage, displayPageOutOfTotal, handlePageChange, showPagination, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters } = useServiceError({ autopopData, projectChanged })

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Service Errors</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className="inspectra-date-string">{dateConvert(filterValues?.date?.from_date, "date-time-months")} - {dateConvert(filterValues?.date?.to_date, "date-time-months")}</div>
            <div className="inspectra-widget-content">
                {loader ? <SkeletonContainer /> :
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                }
            </div>

            <div className="position-absolute bottom-0 end-0 me-1 fs-6 c-pointer" onClick={() => setExpand(true)}>
                <FontAwesomeIcon icon="fa-solid fa-expand" />
            </div>

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Server Error Filters">
                <div>
                    <div className="d-flex gap-2 inspectra-calendar">
                        <div className="w50">
                            <div>Date: </div>
                            <div>
                                <DatePicker portal zIndex={99999} value={hoveredRange} onChange={handleDateRange} range rangeHover placeholder="Select Date Range" style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="w45 d-flex gap-2 justify-content-between">
                            <div className="w50">
                                <div>From Time: </div>
                                <TimePicker value={time?.from || null} onChange={(e) => setTime((prev) => ({ ...prev, from: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                            <div className="w50">
                                <div>To Time: </div>
                                <TimePicker value={time?.to || null} onChange={(e) => setTime((prev) => ({ ...prev, to: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Service:</div>
                            <MultiSelect options={autopopData?.service_name} placeholder="Service" value={filterValues?.service} onChange={(e) => setFilterValues((prev) => ({ ...prev, service: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'service', filterValues?.service, () => setFilterValues((prev) => ({ ...prev, service: [] })))} filter filterInputAutoFocus />
                        </div>
                        <div className="w50">
                            <div>Server:</div>
                            <MultiSelect options={autopopData?.server} placeholder="Server" value={filterValues?.server} onChange={(e) => setFilterValues((prev) => ({ ...prev, server: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'server', filterValues?.server, () => setFilterValues((prev) => ({ ...prev, server: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => handleDefaultFilters()}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => { setShowPopup(false); setExpandedIndex(null); setCurrentPage(1); }} draggable={false} className="modal-xlarge" header="Service Errors Details">
                <div>
                    <div className="inspectra-ping-error">
                        {popupData?.map((item, index) => (
                            <div key={index} className="d-flex flex-column row-gap-1 p-2">
                                <div className="pb-3">
                                    <span style={{ color: "rgb(43 192 98)" }}>$ </span>
                                    <span style={{ color: "rgb(43 112 192)" }}>{new Date(item?.create_date).toLocaleString()}</span>
                                    <span style={{ color: "rgb(255 17 163)" }}> [{item?.service_name}] </span>
                                    <span style={{ color: "rgb(229 221 66)" }}>({item?.server}) </span>
                                    <div style={{ color: "rgb(231 54 35)" }} className="d-flex justify-content-between">
                                        <div className="text-truncate w70">{item?.error_key}</div>
                                        <div className="c-pointer" onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}>
                                            <FontAwesomeIcon icon={`fa-solid fa-caret-${expandedIndex === index ? "up" : "down"}`} />
                                        </div>
                                    </div>
                                    {expandedIndex === index &&
                                        <span className="pt-2" style={{ color: "rgb(231 54 35)", wordBreak: "break-word" }}>{item?.error_details}</span>
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                    {showPagination &&
                        <div>
                            <Pagination totalPages={totalPages} currentPage={currentPage} displayPageOutOfTotal={displayPageOutOfTotal} onPageChange={handlePageChange} />
                        </div>
                    }
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Server Error Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                </div>
            </Dialog>
        </div>
    )
}

export default ServiceError